import { Link } from "react-router-dom";
import Seo from "../Components/Seo.jsx";
import PageHeader from "../Components/PageHeader.jsx";
import { EnquiryCta } from "../Components/SiteInfo.jsx";
import { aboutData, aboutTopics } from "../constants/data.jsx";
import lampPhoto from "../assets/Images/about-lamp-3.jpg";

const PATH = "/about/";

const About = () => (
  <>
    <Seo path={PATH} />
    <PageHeader
      title="About Western Sydney Tamil Study Centre"
      breadcrumbs={[
        { label: "Home", href: "/", icon: "bi-house" },
        { label: "About Us", active: true },
      ]}
    />

    <section className="py-5">
      <div className="container py-lg-4">
        <div className="row g-4 g-lg-5 align-items-center">
          <div className="col-lg-7">
            <p className="fs-5 mb-3">
              Western Sydney Tamil Study Centre (WSTSC) is a not-for-profit
              community language school that supports Tamil language education
              outside mainstream school hours.
            </p>
            <p className="text-muted mb-3">
              We work closely with parents, volunteers and community leaders to
              deliver structured, age-appropriate Tamil programs. Our aim is a
              safe, inclusive and engaging place where students build strong
              Tamil language skills, cultural identity and confidence. They also
              build connections with the wider Tamil community in Western Sydney.
            </p>
            <p className="text-muted mb-0">
              Classes are held at Walters Road Public School in Blacktown.{" "}
              <Link to="/tamil-classes-blacktown/" className="red-text fw-semibold">
                Find out about our Tamil classes
              </Link>
              .
            </p>
          </div>
          <div className="col-lg-5">
            <img
              src={lampPhoto}
              alt="Committee members and teachers lighting the traditional lamp at a WSTSC ceremony"
              className="img-fluid rounded-5 border-bottom-left shadow-sm"
              width="960"
              height="640"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>

    <section className="py-5" style={{ background: "#f9f9f9" }}>
      <div className="container">
        <div className="row g-4">
          {aboutData.map((block) => (
            <div className="col-md-6" key={block.title}>
              <div className="h-100 bg-white border rounded-4 border-bottom-left p-4">
                <h2 className="fs-3 fw-bold green-text mb-3">{block.title}</h2>
                <ul className="text-muted mb-0">
                  {block.content.map((line) => (
                    <li key={line} className="mb-1">{line}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-5">
      <div className="container">
        <div className="row g-4 g-lg-5">
          {aboutTopics.map((topic) => (
            <div className="col-lg-6" key={topic.id} id={topic.id}>
              <h2 className="fs-3 fw-bold mb-3">{topic.title}</h2>
              <p className="text-muted">{topic.description}</p>
              {topic.focusTitle && <p className="fw-bold mb-2">{topic.focusTitle}</p>}
              <ul className="text-muted">
                {topic.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              {topic.bottomText && <p className="text-muted mb-0">{topic.bottomText}</p>}
              {topic.id === "teachers" && (
                <Link to="/" state={{ scrollTo: "team" }} className="green-text fw-semibold text-decoration-none">
                  Meet our teachers and volunteers
                  <i className="bi bi-arrow-right ms-1" aria-hidden="true"></i>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>

    <EnquiryCta />
  </>
);

export default About;
